





























































































import Vue from 'vue';
import AddRedemptionModal from '@/web/components/customers/AddRedemptionModal.vue';
import { getActivePunches, getUsedPunches } from '@/core/utils/classcards';
import { sanitize } from '@/core/utils/utils';
import { mapGetters } from 'vuex';
import { errorToMessage } from '@/core/utils/errors';
import CustomerDetailActionBar from '@/web/components/customers/CustomerDetailActionBar.vue';

export default Vue.extend({
  name: 'CustomerDetailClassCard',
  components: {
    CustomerDetailActionBar,
  },
  computed: {
    ...mapGetters('sale', ['customerAvailablePunches', 'customerPunches']),
    redemptionsAvailable() {
      return sanitize(
        this.$tc(
          'CUSTOMERS.TEXT.COUNT_REDEMPTIONS_AVAILABLE',
          this.customerAvailablePunches
        )
      );
    },
    creditsUsedOrExpired() {
      return sanitize(
        this.$tc(
          'CUSTOMERS.TEXT.COUNT_CREDITS_USED_OR_EXPIRED',
          this.getUsedPunches.length
        )
      );
    },
    getActivePunches() {
      return getActivePunches(this.customerPunches);
    },
    getUsedPunches() {
      return getUsedPunches(this.customerPunches);
    },
  },
  data() {
    return {
      showExpired: false,
      addingRedemption: false,
      customerPunchesFields: [
        {
          name: 'classcard_name',
          title: this.$t('CUSTOMERS.TABLE.CLASSCARD'),
        },
        {
          name: 'number_of_punches',
          title: this.$t('CUSTOMERS.TABLE.AVAILABLE_REDEMPTIONS'),
        },
        {
          name: 'expiration',
          title: this.$t('CUSTOMERS.TABLE.EXPIRATION_DATE'),
        },
        {
          name: 'edit',
        },
      ],
      customerExpiredCreditFields: [
        {
          name: 'event_name',
          title: this.$t('CUSTOMERS.TABLE.EVENT'),
        },
        {
          name: 'event_datetime',
          title: this.$t('CUSTOMERS.TABLE.EVENT_TIME'),
        },
        {
          name: 'purchased',
          title: this.$t('CUSTOMERS.TABLE.PURCHASE_DATE'),
        },
        {
          name: 'expiration',
          title: this.$t('CUSTOMERS.TABLE.EXPIRATION_DATE'),
        },
      ],
    };
  },
  methods: {
    addRedemption(productId) {
      this.$modal.show(AddRedemptionModal, { productId });
    },
    async removeRedemption(productId, expiration) {
      try {
        await this.$store.dispatch('sale/removeCustomerPunch', {
          productId,
          expiration,
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to remove a redemption',
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
    },
  },
  async mounted() {
    this.$store.dispatch('sale/getCustomerPunches');
  },
});
